import React from "react";
import { Box, Typography } from "@mui/material";
import { Person, Business, Visibility } from "@mui/icons-material";

const CountInfo = ({ sections, showHeader = false }) => {
  return (
    <Box
      sx={{ display: "flex", gap: "16px", flexWrap: "wrap", marginTop: "16px" }}
    >
      {sections.length === 0 ? (
        <>
          <Box
            sx={{
              backgroundColor: "white",
              borderRadius: "12px",
              flex: 1,
              textAlign: "center",
              padding: showHeader ? "20px" : "0",
            }}
          >
            <Person sx={{ fontSize: showHeader ? 100 : 70, color: "grey" }} />
            <Typography sx={{ fontSize: "16px", color: "#757575" }}>
              No Employers
            </Typography>
          </Box>
          <Box
            sx={{
              backgroundColor: "white",
              borderRadius: "8px",
              flex: 1,
              textAlign: "center",
              padding: showHeader ? "20px" : "0",
            }}
          >
            <Business sx={{ fontSize: showHeader ? 100 : 70, color: "grey" }} />
            <Typography sx={{ fontSize: "16px", color: "#757575" }}>
              No Companies
            </Typography>
          </Box>
          <Box
            sx={{
              backgroundColor: "white",
              borderRadius: "8px",
              flex: 1,
              textAlign: "center",
              padding: showHeader ? "20px" : "0",
            }}
          >
            <Visibility
              sx={{ fontSize: showHeader ? 100 : 70, color: "grey" }}
            />
            <Typography sx={{ fontSize: "16px", color: "#757575" }}>
              No Active Viewers
            </Typography>
          </Box>
        </>
      ) : (
        sections.map((section) => (
          <Box
            key={section.title}
            sx={{
              backgroundColor: "white",
              borderRadius: "12px",
              flex: 1,
            }}
          >
            {/* Section Header - Visible only when showHeader is true */}
            {showHeader && (
              <Box
                sx={{
                  backgroundColor: "#F9F9F9",
                  display: "flex",
                  height: "44px",
                  padding: "0px 24px",
                  justifyContent: "space-between",
                  alignItems: "center",
                  alignSelf: "stretch",
                  borderRadius: "12px 12px 0 0",
                }}
              >
                <Typography sx={{ fontSize: "18px", fontWeight: "600" }}>
                  {section.title}
                </Typography>
              </Box>
            )}

            {/* Data Rows */}
            <Box
              sx={{
                display: "flex",
                gap: "16px",
                flexDirection: "row",
                justifyContent: "space-between",
                padding: showHeader ? "16px" : "0",
                flexWrap: "wrap",
              }}
            >
              {section.data.map((item, idx) => (
                <Box
                  key={idx}
                  sx={{
                    border: "1px solid rgba(0, 108, 183, 0.20)",
                    borderRadius: "10px",
                    padding: "14px",
                    textAlign: "start",
                    flex: 1,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "24px",
                      fontWeight: 600,
                    }}
                  >
                    {item.value}
                  </Typography>
                  <Typography sx={{ fontSize: "14px", fontWeight: 300 }}>
                    {item.label}
                  </Typography>
                  </Box>
              ))}
            </Box>
          </Box>
        ))
      )}
    </Box>
  );
};

export default CountInfo;
